import 'angular';
import {identity} from 'lodash-es';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';
import './TasksDirectives';
import '../shared/resourceSelection/resourceSelection';

function TasksConfigFunction($routeProvider) {
    var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';        
    function resolveUserInfo () {
        return ['AuthService', '$location', '$q', '$log', function (authService, $location, $q, $log) {                        
            return authService.getUserInfo(false).then(null, function(error) {
                $log.error("Encountered error while fetching userInfo inside resolveUserInfo of taskContoller module.ts");
                $location.url('/genericError');
                $q.reject(error);
            });
        }];
    }

    $routeProvider
    .when('/tasks', {
        auth: true,
        templateUrl: TEMPLATE_LAYOUT,
        controller: 'TasksController',
        resolve: {
            userInfo: resolveUserInfo(),                    
            View: identity.bind(null, AppConstants.Tasks.Views.MyTasks),
            featureMap: ['FeatureManagerService', '$location', '$q', '$log', function(featureManagerService, $location, $q, $log) {
                return featureManagerService.getEnabledFeatureMap().then(null, function(error) {
                    $log.error("Encountered error while fetching enabledFeatureMap inside featureManagerService of taskContoller module.ts");
                    $location.url('/genericError');
                    $q.reject(error);
                });
            }]
        }
    })
    .when('/archivedTasks', {
        auth: true,
        templateUrl: TEMPLATE_LAYOUT,
        controller: 'TasksController',
        resolve: {
            userInfo: resolveUserInfo(),                    
            View: identity.bind(null, AppConstants.Tasks.Views.ArchivedTasks),
            featureMap: ['FeatureManagerService', '$location', '$q', '$log', function(featureManagerService, $location, $q, $log) {
                return featureManagerService.getEnabledFeatureMap().then(null, function(error) {
                    $log.error("Encountered error while fetching enabledFeatureMap inside featureManagerService of taskContoller module.ts");
                    $location.url('/genericError');
                    $q.reject(error);
                });
            }]
        }
    })
    .when('/assignedTasks', {
        auth: true,
        templateUrl: TEMPLATE_LAYOUT,
        controller: 'TasksController',
        resolve: {
            userInfo: resolveUserInfo(),           
            View: identity.bind(null, AppConstants.Tasks.Views.AssignedTasks),
            featureMap: ['FeatureManagerService', '$location', '$q', '$log', function(featureManagerService, $location, $q, $log) {
                return featureManagerService.getEnabledFeatureMap().then(null, function(error) {
                    $log.error("Encountered error while fetching enabledFeatureMap inside featureManagerService of taskContoller module.ts");
                    $location.url('/genericError');
                    $q.reject(error);
                });
            }]
        }
    });
};

TasksConfigFunction.$inject = ['$routeProvider'];
angular.module('GorillaBoy.Tasks')
.config(TasksConfigFunction);
